module.exports = __webpack_public_path__ + "static/media/fij.49987304.svg";